import React, { createContext, useContext, useState } from 'react'
import { getLivePayloadData } from '../../../../helper/user-helper'
import { useApplicationContext } from '../../../../context/ApplicationContext'

export const getLoadingStages = (response, loadState = false) => {
  //handle ids on retry click
  return response.reduce((acc, cur) => ({ ...acc, [cur]: loadState }), {})
}

export const addCount = (debugIds, currentCount = {}) => {
  const debugs = { ...currentCount }

  debugIds.forEach((d) => {
    if (!debugs[d]) {
      debugs[d] = 1
    } else {
      debugs[d] += 1
    }
  })
  return debugs
}

// Create a guide Context for live data
export const UpgradeGuideContext = createContext({
  getTransformData: () => {},
  setIsBannerOpen: () => {},
  transformDataLoading: {
    isTransformDataLoading: {},
  },
  isBannerOpen: {},
  transFormData: null,
})

// Create a Provider Component for upgrade guide live payload
const UpgradeGuideProvider = ({ children }) => {
  const [transformDataLoading, setTransformDataLoading] = useState({
    isTransformDataLoading: {},
  })
  //create state to open and close banner on component level
  const [isBannerOpen, setIsBannerOpen] = useState({})
  //set new state for live payload data to avoid re-renderings
  const [transFormData, setTransformData] = useState()
  //required token for live data
  const { csrf } = useApplicationContext()

  //fetch live data
  const getTransformData = async (debugIds) => {
    try {
      setTransformDataLoading((prev) => ({
        ...prev,
        isTransformDataLoading: getLoadingStages(debugIds, true),
      }))

      //api call
      const data = await getLivePayloadData(csrf, debugIds)

      //update live payload data on retry
      setTransformDataLoading((prev) => ({
        ...prev,
        isTransformDataLoading: getLoadingStages(debugIds, false),
      }))

      //set live data in state
      setTransformData((prev) => ({
        ...prev,
        ...data,
      }))
    } catch (error) {
      console.error('Error fetching transform data: ', error)
      //reset loading of live data if error occurs
      setTransformDataLoading((prev) => ({
        ...prev,
        isTransformDataLoading: getLoadingStages(debugIds, false),
      }))
    }
  }

  return (
    <UpgradeGuideContext.Provider
      value={{
        transformDataLoading,
        getTransformData,
        isBannerOpen,
        setIsBannerOpen,
        transFormData,
      }}
    >
      {children}
    </UpgradeGuideContext.Provider>
  )
}

export default UpgradeGuideProvider

export const useUpgradeGuideContext = () => useContext(UpgradeGuideContext)
